import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from 'app/shared.module';
import { DataVisualizationSharedModule } from 'app/shared/components/data-visualization';
import { TestDataAgentSSEModule } from 'app/test/components/data-agent-sse/test-data-agent-sse.module';
import { InsightsSuggestionsPanelComponent } from './insights-suggestions-panel.component';
import { InsightDetailModalComponent } from './insight-detail-modal.component';

@NgModule({
  declarations: [InsightsSuggestionsPanelComponent, InsightDetailModalComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    SharedModule,
    DataVisualizationSharedModule,
    TestDataAgentSSEModule,
  ],
  exports: [InsightsSuggestionsPanelComponent],
})
export class InsightsSuggestionsPanelModule {}
